// extracted by mini-css-extract-plugin
export default {"box":"box--eRTjj","boxItems":"boxItems--vovjD"};